import { Component } from '@angular/core';
import { Group_Library } from 'src/app/Interfaces/Interfaces-Global/Libraries.interface';
import { GeneralLibraryCDMS, typeSystemLibraryCDMS } from 'src/app/types/General/Library.type';

@Component({
    selector: 'app-sall-templates-cdms',
    templateUrl: './sall-templates-cdms.component.html',
    styleUrls: ['./sall-templates-cdms.component.scss', '../../../Styles/GlobalStyles.css', '../../../Styles/LibrayGlobal.css', '../../../Styles/TasksGlobal.css'],
    standalone: false
})
export class SAllTemplatesCDMSComponent {

  //+================== VARIABLE LIBRARY GENERAL ==================+\\
  public LibraryGeneral: typeSystemLibraryCDMS = GeneralLibraryCDMS;

  //+================== VARIABLES FOR OPTION CARDS LIBRARIES ==================+\\
  public AllLibraries: Group_Library[] = [
    {
      Title: 'Librerías CDMS',
      NotRelated: [],
      LibraryRole: [this.LibraryGeneral.CCP],
      Library: [
        { Library: 'CCP', RouteLink: '/Dashboard/CCP/SeeTemplatesInCCP', Description: 'puede revisar las plantillas de la librería CCP.', Key: this.LibraryGeneral.CCP, Img: 'CCP' },
      ],
    }
  ]

  //&===================== FUNCTIONS FOR GENERAL COMPONENT =====================&\\

  //-================== FUNCTTION FOR GREETTING ==================-\\
  public GetGreeting(): string {

    let TextGTings: string = '';

    const Date_User = new Date();
    const Hour = Date_User.getHours();

    if (Hour >= 0 && Hour <= 5) {
      TextGTings = 'Buenas noches';
    } else if (Hour >= 6 && Hour <= 11) {
      TextGTings = 'Buenos días';
    } else if (Hour >= 12 && Hour <= 17) {
      TextGTings = 'Buenas tardes';
    } else if (Hour >= 18) {
      TextGTings = 'Buenas noches';
    }

    return TextGTings;
  }

  //-================ FUNCTION FOR NAME USER ================-\\
  public NameUser(): string {
    const Name_User: string = localStorage.getItem('Name_User') || "";
    return (Name_User.split(' ', 2)).join(' ');
  }


  //&===================== END FUNCTIONS FOR GENERAL COMPONENT =====================&\\

}
